<!--
 * @Description:
 * @Version: 2.0
 * @Autor: JF
 * @Date: 2022-02-17 09:15:29
 * @LastEditors: JF
 * @LastEditTime: 2022-02-17 11:25:22
-->
<template>
  <div class="all display_A_C display_J_C">
    <!-- <img class="bg" src="./img/login_bg.png" alt="" /> -->
    <img class="bg" src="./img/login_bg_1.png" alt="" />
    <div class="cont">
      <!-- 点 -->
      <div class="c_tblr c_tl"></div>
      <div class="c_tblr c_tr"></div>
      <div class="c_tblr c_bl"></div>
      <div class="c_tblr c_br"></div>
      <!-- 线 -->
      <div id="x_t" class="x_tblr x_t animated"></div>
      <div class="x_tblr x_b"></div>
      <div class="x_tblr x_l"></div>
      <div class="x_tblr x_r"></div>
      <!-- <img class="bg2" src="./img/login_bg2.png" alt=""> -->
      <img class="bg3" src="./img/login_bg3.png" alt="" />
      <div class="bg_icon1"></div>
      <div class="bg_icon2"></div>
      <div class="bg_icon3"></div>
      <div class="c_cont">
        <div class="cc_1" style="display: flex;">
          <span>登录</span>
          <span
            class="login_error"
            style="display: flex;align-items: center;margin-left: 1.4vw;"
          >
            <img class="login_error_img" src="./img/login_error.png" />
            <span class="login_error_text"></span>
          </span>
        </div>
        <div class="cc_2 display_J_S" style="margin-top: 1vw;">
          <div class="cc_2_img display_A_C">
            <img src="./img/login_zhh.png" alt="" />
          </div>
          <div class="cc_2_ipt display_A_C">
            <input
              id="username"
              v-model="loginName"
              type="text"
              placeholder="请输入账号"
              autocomplete="off"
              @blur="e => blur(e, 'username')"
              @focus="e => focus(e, 'username')"
              @input="e => input(e, 'username')"
            />
          </div>
          <div
            ref="username"
            class="cc_2_del display_A_C"
            @click="e => closeValue(e, 'username')"
          >
            <img src="./img/login_del.png" alt="" />
          </div>
        </div>
        <div class="cc_2 display_J_S">
          <div class="cc_2_img display_A_C">
            <img src="./img/login_mm.png" alt="" />
          </div>
          <div class="cc_2_ipt display_A_C">
            <input
              id="userpwd"
              v-model="password"
              type="password"
              placeholder="请输入密码"
              autocomplete="off"
              @blur="e => blur(e, 'password')"
              @focus="e => focus(e, 'password')"
              @input="e => input(e, 'password')"
            />
          </div>
          <div
            ref="password"
            class="cc_2_del display_A_C"
            @click="e => closeValue(e, 'password')"
          >
            <img src="./img/login_del.png" alt="" />
          </div>
        </div>
<!--        <div id="verify-wrap" class="verify-wrap"></div>-->
        <!-- <div id="captcha"></div> -->
        <div class="cc_4" @click="login()">登录</div>
      </div>
    </div>

    <a
      href="https://beian.miit.gov.cn/"
      style="text-decoration: none;user-select: none;position: absolute;bottom: 1vh;color: rgb(20,255,251,0.5);cursor: pointer;"
      >皖ICP备2023002782号-3</a
    >
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      loginName: "",
      password: "",
      // slideVerify: null
    };
  },

  mounted() {
    this.initPage();
  },

  methods: {
    login() {
      // console.log(this.slideVerify);
      if (this.loginName == "" || this.password == "") {
        $(".login_error").css("display", "flex");
        $(".login_error_text").html("请输入用户名和密码!");
        return false;
      } else if (this.password.length < 6) {
        $(".login_error").css("display", "flex");
        $(".login_error_text").html("密码最少6位!");
        return false;
      }
      // if (!this.slideVerify.slideFinishState) {
      //   $(".login_error").css("display", "flex");
      //   $(".login_error_text").html("请拖动滑块!");
      //   return false;
      // }
      this.$api.user
        .login({
          loginName: this.loginName,
          password: this.password
        })
        .then(result => {
          console.log(result);
          if (result.code == 1) {
            let tokenObj = {
              token: result.accessToken,
              tokenExpireTime: ""
            };
            this.$Cookies.set("evmall_token", tokenObj);
            this.$Cookies.set("user", JSON.stringify(result.data));
            this.$router.replace("/");
          }
        })
        .catch(err => {});
    },
    input(e, type) {
      if (e.target.value != "") {
        this.$refs[type].style.visibility = "visible";
      } else {
        this.$refs[type].style.visibility = "hidden";
      }
    },
    blur(e, type) {
      setTimeout(() => {
        this.$refs[type].style.visibility = "hidden";
      }, 100);
    },
    focus(e, type) {
      if (e.target.value != "") {
        this.$refs[type].style.visibility = "visible";
      }
    },
    closeValue(e, type) {
      if (type == "username") {
        this.loginName = "";
      } else {
        this.password = "";
      }
      this.$refs[type].style.visibility = "hidden";
    },
    initPage() {
      $(".cc_2_ipt input").focus(function() {
        $(".cc_2").css("border-bottom", "1px solid rgba(19,255,252,0.3)");
        $(this)
          .parents(".cc_2")
          .css("border-bottom", "1px solid rgba(19,255,252,1)");

        // $(this)
        //   .parents(".cc_2")
        //   .children(".cc_2_del")
        //   .css("visibility", "visible");
      });

      $(".login_error").css("display", "none");

      // let SlideVerifyPlug = window.slideVerifyPlug;
      // this.slideVerify = new SlideVerifyPlug("#verify-wrap", {
      //   wrapWidth: "100%", //设置 容器的宽度 ,不设置的话，会设置成100%，需要自己在外层包层div,设置宽度，这是为了适应方便点；
      //   initText: "请向右滑动滑块", //设置  初始的 显示文字
      //   sucessText: "验证通过", //设置 验证通过 显示的文字
      //   getSuccessState: function(res) {
      //     //当验证完成的时候 会 返回 res 值 true，只留了这个应该够用了
      //     if (res) {
      //       let loginName = $("#username").val();
      //       let password = $("#userpwd").val();
      //       if (loginName == "" || password == "") {
      //         $(".login_error").css("display", "flex");
      //         $(".login_error_text").html("请输入用户名和密码!");
      //         $(".fix-tips").html("请向右滑动滑块");
      //         setTimeout(function() {
      //           this.slideVerify.resetVerify();
      //         }, 1);
      //       } else {
      //         $(".login_error").css("display", "none");
      //         $(".login_error_text").html("");
      //         $(".fix-tips").html("");
      //       }
      //     }
      //   }
      // });

      $(".x_t").addClass("animated");
      $(".x_b").addClass("animated");
      $(".x_l").removeClass("animated");
      $(".x_r").removeClass("animated");
      $(".x_t").on("animationend", function() {
        $(".x_t").removeClass("animated");
        $(".x_l").addClass("animated");
      });
      $(".x_l").on("animationend", function() {
        $(".x_l").removeClass("animated");
        $(".x_b").addClass("animated");
      });
      $(".x_b").on("animationend", function() {
        $(".x_b").removeClass("animated");
        $(".x_r").addClass("animated");
      });
      $(".x_r").on("animationend", function() {
        $(".x_r").removeClass("animated");
        $(".x_t").addClass("animated");
      });
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
